






















/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Module Helper
---------------------------------------- */

import { StoreModule } from "@store/service/Modules";
const module = new StoreModule('cases');

/* ----------------------------------------
    Cards
---------------------------------------- */

import Case from '@part/cards/Case';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    props: {
        content: Object
    },

    components: {
        Case
    },

    computed: {
        projects() {
            return module.getters('getCasesByNames', this.content.cases);
        }
    }

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Work extends Vue {}

